module.exports = __webpack_public_path__ + "img/fran-1.08530b4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/fran-1.png
// module id = 1646
// module chunks = 1